import { render } from "./TimelineHorizontal.vue?vue&type=template&id=130f0b9c&scoped=true"
import script from "./TimelineHorizontal.vue?vue&type=script&lang=js"
export * from "./TimelineHorizontal.vue?vue&type=script&lang=js"

import "./TimelineHorizontal.vue?vue&type=style&index=0&id=130f0b9c&scoped=true&lang=css"

import exportComponent from "/root/projects/website/vue-notus-main/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130f0b9c"]])

export default __exports__